import React from 'react';
import Header from './components/layout/Header';
import Toolbar from './components/layout/Toolbar';
import Canvas from './components/canvas/Canvas';
import PropertiesPanel from './components/panels/PropertiesPanel';
import WelcomeModal from './components/modals/WelcomeModal';
import TutorialModal from './components/modals/TutorialModal';
import useEditorStore from './store/editorStore';
import './App.css';

function App() {
  const { 
    initializeDefaultSections, 
    sections, 
    deleteBlock, 
    selectedBlockId,
    clearCanvas 
  } = useEditorStore();
  
  const [showWelcome, setShowWelcome] = React.useState(false);
  const [showTutorial, setShowTutorial] = React.useState(false);
  const [tutorialStep, setTutorialStep] = React.useState(0);
  
  // Check if user has seen welcome modal before
  React.useEffect(() => {
    const hasSeenWelcome = localStorage.getItem('hideWelcomeModal');
    if (!hasSeenWelcome) {
      setShowWelcome(true);
    }
  }, []);
  
  // Initialize default sections on mount
  React.useEffect(() => {
    if (sections.length === 0) {
      initializeDefaultSections();
    }
  }, []);

  // Handle keyboard shortcuts
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      // Ignore if user is typing in an input or textarea
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName) || 
          document.activeElement.isContentEditable) {
        return;
      }

      // Delete block
      if ((e.key === 'Delete' || e.key === 'Backspace') && selectedBlockId) {
        e.preventDefault();
        deleteBlock(selectedBlockId);
      }

      // Undo/Redo (Placeholder for future implementation)
      if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
        e.preventDefault();
        // undo();
        console.log('Undo not implemented yet');
      }
      if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.shiftKey && e.key === 'z'))) {
        e.preventDefault();
        // redo();
        console.log('Redo not implemented yet');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedBlockId, deleteBlock]);

  const handleSelectTemplate = () => {
    // Reload to get default template
    window.location.reload();
  };

  const handleCreateOwn = () => {
    // Clear canvas and start from scratch
    clearCanvas();
  };

  const handleShowTutorial = () => {
    setShowTutorial(true);
    setTutorialStep(0);
  };

  const handleNextStep = () => {
    if (tutorialStep < 3) {
      setTutorialStep(tutorialStep + 1);
    }
  };

  const handlePreviousStep = () => {
    if (tutorialStep > 0) {
      setTutorialStep(tutorialStep - 1);
    }
  };

  const handleFinishTutorial = () => {
    setShowTutorial(false);
    setTutorialStep(0);
  };
  
  return (
    <div className="app">
      <Header onShowTutorial={handleShowTutorial} />
      <div className="app-body">
        <Toolbar />
        <div className="canvas-container">
          <Canvas />
        </div>
        <PropertiesPanel />
      </div>

      {showWelcome && (
        <WelcomeModal
          onClose={() => setShowWelcome(false)}
          onSelectTemplate={handleSelectTemplate}
          onCreateOwn={handleCreateOwn}
          onShowTutorial={handleShowTutorial}
        />
      )}

      {showTutorial && (
        <TutorialModal
          onClose={() => setShowTutorial(false)}
          currentStep={tutorialStep}
          onNext={handleNextStep}
          onPrevious={handlePreviousStep}
          onFinish={handleFinishTutorial}
        />
      )}
    </div>
  );
}

export default App;
